if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      variant_metafields = undefined;
      variant_metafield_obj = undefined;
      constructor() {
        super();
        this.debug = false;
        if (this.debug) console.log('constructor called');
      }

      showButtonsLoadingState() {
        const actualButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        const buyBarButton = document.querySelector('.product-buy-bar-add');

        actualButton?.classList.add('disabled');
        buyBarButton?.classList.add('disabled');
      }

      hideButtonsLoadingState(html) {
        const fetchedButton = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
        const actualButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        const buyBarButton = document.querySelector('.product-buy-bar-add');
        const customizeModalEl = document.querySelector('.product-customize');

        const isFetchedButtonDisabled = fetchedButton?.hasAttribute('disabled');
        const isFetchedButtonHidden = fetchedButton?.classList.contains('tw-hidden');

        if (fetchedButton && actualButton) {
          actualButton.innerHTML = fetchedButton.innerHTML;

          if (isFetchedButtonDisabled) {
            actualButton.setAttribute('disabled', 'disabled');
            actualButton.classList.add('disabled', 'disabled:!tw-bg-gray', 'disabled:!tw-border-gray');
            if (isFetchedButtonHidden) {
              actualButton.classList.add('tw-hidden');
            } else {
              actualButton.classList.remove('tw-hidden');
            }
            buyBarButton?.classList.add('disabled:!tw-bg-gray', 'disabled:!tw-border-gray');
            customizeModalEl?.classList.add('disabled');
          } else {
            actualButton.removeAttribute('disabled');
            actualButton.classList.remove('disabled');
            if (!isFetchedButtonHidden) actualButton.classList.remove('tw-hidden');
            buyBarButton?.classList.remove('disabled', 'disabled:!tw-bg-gray', 'disabled:!tw-border-gray');
            customizeModalEl?.classList.remove('disabled');
          }
        }
      }

      connectedCallback() {
        if (this.debug) console.log('connectedCallback');

        this.quantityInput = this.querySelector('.quantity__input');
        this.variant_metafields = JSON.parse(this.querySelector('[data-variant-metafields]').innerHTML);
        this.combinedListingRefsDataEl = this.querySelector('[data-combined-listing-refs-json]');
        if (this.combinedListingRefsDataEl) {
          this.combinedListingRefsData = JSON.parse(this.combinedListingRefsDataEl.innerHTML);
        }

        this.scrollAndClick();

        // add event listener for personalizationUpdated event
        document.addEventListener('personalizationUpdated', () => {
          this.shipsIn();
        });

        window.addEventListener('load', this.loadLazyImagesWithFallback);

        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.addSubscriptionListeners();

        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
        const variant = this.getSelectedVariant(this);
        this.updateDeliveryTime(variant);
        this.scrollAndClick();
        this.waitForYotpo();
      }

      waitForYotpo() {
        const checkInterval = setInterval(() => {
          if (window.yotpoWidgetsContainer) {
            clearInterval(checkInterval); // Stop checking once it's available
            this.initializeYotpoWidgets(window.yotpoWidgetsContainer); // Call your logic
          }
        }, 100);
      }

      initializeYotpoWidgets(container) {
        yotpoWidgetsContainer.initWidgets();
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();
        this.showButtonsLoadingState();

        const fetchUrlData = this.getCorrectfetchUrl(event.target);

        this.renderProductInfo({
          requestUrl: fetchUrlData.productUrl,
          targetId: target.id,
          callback: fetchUrlData.shouldSwapProduct
            ? this.handleSwapProduct(fetchUrlData.productUrl, fetchUrlData.shouldFetchFullPage)
            : this.handleUpdateProductInfo(fetchUrlData.productUrl),
        });
      }

      getCorrectfetchUrl(target) {
        if (this.debug) console.log('getCorrectfetchUrl called');

        const newVariantId = target.dataset.variantId;
        const newProductUrl = target.dataset.productUrl;
        const currentProductUrl = this.dataset.url;
        const optionValue = target.value;
        let fetchUrl = null;

        // Utility to extract base URL
        const getBaseUrl = (url) => url?.split('?')[0] || '';

        // Utility to collect selected options
        const getSelectedOptions = () => {
          const selectedOptions = Array.from(
            this.querySelectorAll('select option[selected], fieldset input:checked')
          ).map((element) => ({ value: element.value, optionId: element.dataset.optionValueId }));
          if (this.debug) console.log('Selected options:', selectedOptions);
          return selectedOptions;
        };

        const selectedOptions = getSelectedOptions();

        if (!this.combinedListingRefsData) {
          if (this.debug) console.warn('Combined listing refs data not found. Returning default.');

          if (newVariantId && newProductUrl) {
            if (this.debug) console.log('Case: newVariantId and newProductUrl found');
            fetchUrl = `${newProductUrl}?option_values=${selectedOptions.map((option) => option.optionId).join(',')}`;
          } else if (!newVariantId && !newProductUrl) {
            if (this.debug) console.log('Case: No newVariantId and newProductUrl');
            fetchUrl = `${currentProductUrl}?option_values=${selectedOptions
              .map((option) => option.optionId)
              .join(',')}&section_id=${this.sectionId}`;
          } else if (newVariantId && !newProductUrl) {
            if (this.debug) console.log('Case: newVariantId found, but no newProductUrl');
            fetchUrl = `${currentProductUrl}?variant=${newVariantId}`;
          } else if (!newVariantId && newProductUrl) {
            if (this.debug) console.log('Case: newProductUrl found, but no newVariantId');
            fetchUrl = `${newProductUrl}?option_values=${selectedOptions.map((option) => option.optionId).join(',')}`;
          }

          const shouldSwapProduct = getBaseUrl(currentProductUrl) !== getBaseUrl(fetchUrl);
          const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
          if (this.debug) console.log('Default block result:', { fetchUrl, shouldSwapProduct, shouldFetchFullPage });
          return {
            productUrl: fetchUrl,
            shouldSwapProduct: shouldSwapProduct,
            shouldFetchFullPage: shouldFetchFullPage,
          };
        }

        // Log critical debug information
        if (this.debug)
          console.log('Debug data:', { newVariantId, newProductUrl, currentProductUrl, optionValue, selectedOptions });

        // Utility to find a matching variant
        const findMatchingVariantUrl = (variantId, productUrl) => {
          for (const listing of this.combinedListingRefsData.combined_listing) {
            const variantMatch = listing.child_variants.find((variant) => variant.id === variantId);
            if (variantMatch) {
              if (this.debug) console.log('Matching variant found:', variantMatch);
              return `${productUrl}?variant=${variantId}`;
            }
          }
          return null;
        };

        // Utility to fallback to the first variant matching an option value
        const findFallbackVariantUrl = (optionValue, productUrl) => {
          for (const listing of this.combinedListingRefsData.combined_listing) {
            for (const variant of listing.child_variants) {
              if (variant.option_1 === optionValue) {
                if (this.debug) console.log('Fallback variant found:', variant);
                return `${productUrl}?variant=${variant.id}`;
              }
            }
          }
          return null;
        };

        if (newVariantId && newProductUrl) {
          if (this.debug) console.log('Checking for matching/fallback variant for newVariantId and newProductUrl...');
          fetchUrl =
            findMatchingVariantUrl(newVariantId, newProductUrl) || findFallbackVariantUrl(optionValue, newProductUrl);
        } else if (!newVariantId && !newProductUrl) {
          if (this.debug) console.log('Building fetchUrl for no newVariantId and newProductUrl...');
          fetchUrl = `${currentProductUrl}?option_values=${selectedOptions
            .map((option) => option.optionId)
            .join(',')}&section_id=${this.sectionId}`;
        } else {
          if (this.debug) console.log('Using searchForCorrectfetchUrl utility...');
          fetchUrl = this.searchForCorrectfetchUrl(selectedOptions);
        }

        const shouldSwapProduct = getBaseUrl(currentProductUrl) !== getBaseUrl(fetchUrl);
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        if (this.debug) console.log('Final result:', { fetchUrl, shouldSwapProduct, shouldFetchFullPage });

        return { productUrl: fetchUrl, shouldSwapProduct: shouldSwapProduct, shouldFetchFullPage: shouldFetchFullPage };
      }

      // Helper function to search for sibling URL based on selected options
      searchForCorrectfetchUrl(selectedOptions) {
        if (this.debug) console.log('searchForCorrectfetchUrl called with:', selectedOptions);
        let fetchUrl = null;
        let fallbackHandle = null;

        for (const listing of this.combinedListingRefsData.combined_listing) {
          for (const variant of listing.child_variants) {
            if (
              selectedOptions.length === 2 &&
              variant.option_1 === selectedOptions[0].value &&
              variant.option_2 === selectedOptions[1].value
            ) {
              if (this.debug) console.log('Exact match found:', variant);
              return `${listing.child_handle}?variant=${variant.id}`;
            }
            if (!fallbackHandle && variant.option_1 === selectedOptions[0].value) {
              fallbackHandle = `${listing.child_handle}?variant=${variant.id}`;
            }
          }
        }

        if (this.debug) console.log('searchForCorrectfetchUrl result:', fetchUrl || fallbackHandle);

        return fetchUrl || fallbackHandle;
      }

      resetProductFormState() {
        const productForm = this.productForm;
        // productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();
          if (this.debug) console.log('swapProduct called with:', { productUrl, updateFullPage });

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';

          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }

          const inputs = document.querySelectorAll(`variant-selects input[data-variant-id='${variant?.id}']`);
          if (inputs.length) {
            inputs.forEach((input) => {
              if (!input.checked) {
                input.checked = true;
                console.log(input);
              }
            });
          }

          // update or re-init lazy loading
          if (window.lazyLoadInstance && typeof window.lazyLoadInstance.update === 'function') {
            window.lazyLoadInstance.loadAll();
          }
          if (window.hardResetCustomize && typeof window.hardResetCustomize === 'function') {
            window.hardResetCustomize();
          }
          // reattach personalization modal listeners
          if (window.attachPersonalizationListeners && typeof window.attachPersonalizationListeners === 'function') {
            window.attachPersonalizationListeners();
          }
          // update product summary block
          // *** deprecated: no longer need this as we use liquid to initially set the variant options within main-product.liquid which gets fetched and rerendered by Shopify***
          // this.updateMainProductSummary(variant);

          // reinit simple pdp swiper and reattach listeners
          if (window.reinitProductFeaturesScripts && typeof window.reinitProductFeaturesScripts === 'function') {
            window.reinitProductFeaturesScripts();
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;

        if (!selectedVariant) return null;

        try {
          return JSON.parse(selectedVariant);
        } catch (error) {
          console.error('JSON parsing error:', error);
          return null;
        }
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects [data-selected-variant]');
        const variantSelectsFetch = this.variantSelectors.querySelector('[data-selected-variant]');
        if (variantSelects && variantSelectsFetch) {
          HTMLUpdateUtility.viewTransition(variantSelectsFetch, variantSelects, this.preProcessHtmlCallbacks);
        }

        //change add-on products
        const addOn = html.querySelector('[data-add-on-products]');
        const addOnFetch = this.querySelector('[data-add-on-products]');
        if (addOn && addOnFetch) {
          HTMLUpdateUtility.viewTransition(addOnFetch, addOn, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          this.hideButtonsLoadingState(html);

          // Get the selected variant from the fetched HTML
          const variant = this.getSelectedVariant(html);
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('variant-selects');

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.updateProductDetail(variant);
          this.updateDeliveryTime(variant);
          this.updateMainProductSummary(variant);

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        if (this.debug) console.log('updateURL called with:', { url, variantId });

        // Check if the URL should not be updated
        if (this.dataset.updateUrl === 'false') {
          if (this.debug) console.log('URL update skipped due to dataset.updateUrl being false');
          return;
        }

        // Parse the URL
        const parsedUrl = new URL(url, window.shopUrl);
        if (this.debug) console.log('Parsed URL:', parsedUrl);

        // Ensure '/products/' is in the pathname
        if (!parsedUrl.pathname.includes('/products/')) {
          parsedUrl.pathname = `/products${parsedUrl.pathname}`;
          if (this.debug) console.log('Added "/products/" to pathname:', parsedUrl.pathname);
        }

        // Remove unwanted query parameters
        ['option_values', 'section_id'].forEach((param) => {
          if (parsedUrl.searchParams.has(param)) {
            parsedUrl.searchParams.delete(param);
            if (this.debug) console.log(`Removed query parameter: ${param}`);
          }
        });

        // Check if variantId already exists in the URL, if not, add it
        if (variantId && !parsedUrl.searchParams.has('variant')) {
          parsedUrl.searchParams.set('variant', variantId);
          if (this.debug) console.log('Added variantId to URL:', variantId);
        }

        // Construct the updated URL
        const updatedUrl = `${parsedUrl.pathname}${parsedUrl.search}`;
        if (this.debug) console.log('Updated URL:', updatedUrl);

        // Update the share button if it exists
        const shareButton = this.querySelector('share-button');
        if (shareButton) {
          shareButton.updateUrl(`${window.shopUrl}${updatedUrl}`);
          if (this.debug) console.log('Updated share button URL:', `${window.shopUrl}${updatedUrl}`);
        } else {
          if (this.debug) console.log('No share button found to update');
        }

        // Update the window's history state
        window.history.replaceState({}, '', updatedUrl);
        if (this.debug) console.log('History state updated with URL:', updatedUrl);
      }

      setUnavailable() {
        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      hideAnimation() {
        const animEl = document.querySelectorAll('.Animate');
        if (animEl.length) {
          animEl.forEach((el) => {
            el.classList.remove('Animate--animated');
          });
        }
      }

      showAnimation() {
        const animEl = document.querySelectorAll('.Animate');
        if (animEl.length) {
          animEl.forEach((el) => {
            el.classList.add('Animate--animated');
          });
        }
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) {
          this.querySelectorAll(`[data-variant-index]`).forEach((thumbnail) => {
            thumbnail.classList.remove('full-media');
            thumbnail.classList.remove('hidden');
          });
          return;
        }

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        if (variantFeaturedMediaId) {
          // update media modal
          const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
          const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
          if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;

          const dataTarget = `${this.dataset.section}-${variantFeaturedMediaId}`;
          // get dataTarget element, and then get the variantIndex from it
          const variantIndex = html.querySelector(`[data-target="${dataTarget}"]`)?.dataset.variantIndex;
          // hide all thumbnails that have a variantIndex that doesn't match the current variantIndex
          // wait a second to ensure the new media gallery has been rendered

          this.querySelectorAll(`[data-variant-index]`).forEach((thumbnail) => {
            thumbnail.classList.remove('full-media');
            thumbnail.classList.toggle('hidden', thumbnail.dataset.variantIndex !== variantIndex);
          });

          //Hiding functionality if the thumbnail is only 1
          const thumbnailsImg = [...this.querySelectorAll(`.thumbnail-list__item[data-variant-index]:not(.hidden)`)];

          const typeSlider = this.querySelector(`[data-desktop-layout]`).getAttribute('data-desktop-layout');
          if (typeSlider == 'thumbnail_slider') {
            const thumbnail_slider = this.querySelector(`.thumbnail-slider`);
            const arrow_desktop_slider = this.querySelector(`.arrow_desktop_slider`);
            if (thumbnailsImg.length > 1) {
              if (thumbnail_slider) {
                thumbnail_slider.classList.remove('hide');
              }
              if (arrow_desktop_slider) {
                arrow_desktop_slider.classList.remove('hide');
              }
            }
          }

          // Find all visible elements (without hidden class) after applying the filter
          const visibleThumbnails = [...this.querySelectorAll(`[data-variant-index]:not(.hidden)`)];
          const count = visibleThumbnails.length;

          // If there are 2 visible elements, add the 'full-media' class to the first and the second one.
          if (count === 2) {
            visibleThumbnails[0].classList.add('full-media');
            visibleThumbnails[count - 1].classList.add('full-media');
          }
          // If there are 3 visible elements, add the 'full-media' class only to the first one
          else if (count === 3) {
            visibleThumbnails[0].classList.add('full-media');
          }
          // If there are 4 visible elements, add the 'full-media' class to the first and the last one.
          else if (count === 4) {
            visibleThumbnails[0].classList.add('full-media');
            visibleThumbnails[count - 1].classList.add('full-media');
          }

          // set featured media as active in the media gallery
          this.querySelector(`media-gallery`)?.setActiveMedia?.(
            `${this.dataset.section}-${variantFeaturedMediaId}`,
            true
          );
          this.querySelector(`.product__media-wrapper`).classList.remove('product__media-wrapper--loading');
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      updateDeliveryTime = (variant) => {
        //        console.log('updateDeliveryTime');
        const arr_product_info_bis = document.querySelectorAll('.ProductInfo__bis');
        const prodDelvMsgElems = document.querySelectorAll('[data-pdp-delivery-message]');
        const prodDelvAccentElem = document.querySelector('[data-pdp-delivery-accent]');
        const propertiesDeliveryMessage = document.getElementById('properties-delivery_message');
        const buy_bar_delivery_shipping = document.querySelector(
          '.product-buy-bar-delivery .ProductInfo__shipping-speed'
        );
        if (!variant) {
          prodDelvMsgElems.forEach((prodDelvMsgElem) => {
            // if the innerHTML of prodDelvMsgElem is empty, then we run this.shipsIn()
            if (prodDelvMsgElem.innerHTML === '') {
              prodDelvAccentElem?.classList.add('hidden');
              this.shipsIn();
              propertiesDeliveryMessage.value = '';
              prodDelvAccentElem?.classList.remove('hidden');
            }
          });
        } else {
          const variant_metafield_obj = this.variant_metafields.variants.find((v) => v.id === variant.id);

          // update bis_variant_id of #bis_modal form
          const bisVariantId = document.getElementById('bis_variant_id');
          if (bisVariantId) bisVariantId.value = variant.id;
          // update variant_id on notify me link 'ProductInfo__bis' data-variant-id
          const arr_product_info_bis_variant_id = document.querySelectorAll('.ProductInfo__bis');
          arr_product_info_bis_variant_id.forEach((product_info_bis_variant_id) => {
            product_info_bis_variant_id.dataset.variantId = variant.id;
          });

          prodDelvMsgElems.forEach((prodDelvMsgElem) => {
            //if the variant.sku starts with "GC", then we show the delivery message
            if (variant.sku && variant.sku.startsWith('GC')) {
              arr_product_info_bis.forEach((product_info_bis) => {
                product_info_bis.classList.add('hidden');
              });
              // buy_bar_delivery_shipping.classList.remove('hidden');
              if (prodDelvAccentElem) {
                prodDelvAccentElem.classList.remove('hidden');
              }
            } else if (!variant.available) {
              prodDelvMsgElem.textContent = '';
              // hide delivery accent message
              prodDelvAccentElem?.classList.add('hidden');
              // remove hidden class from .ProductInfo__bis
              arr_product_info_bis.forEach((product_info_bis) => {
                product_info_bis.classList.remove('hidden');
              });
            } else if (variant_metafield_obj.delivery_message) {
              arr_product_info_bis.forEach((product_info_bis) => {
                product_info_bis.classList.add('hidden');
              });
              prodDelvMsgElem.textContent = decodeURI(variant_metafield_obj.delivery_message);
              propertiesDeliveryMessage.value = decodeURI(variant_metafield_obj.delivery_message);
              // buy_bar_delivery_shipping.classList.remove('hidden');
              // show delivery accent message
              prodDelvAccentElem?.classList.remove('hidden');
            } else {
              arr_product_info_bis.forEach((product_info_bis) => {
                product_info_bis.classList.add('hidden');
              });
              this.shipsIn();
              propertiesDeliveryMessage.value = '';
              // buy_bar_delivery_shipping.classList.remove('hidden');
              // show delivery accent message
              prodDelvAccentElem?.classList.remove('hidden');
            }
          });
        }
      };

      shipsIn = () => {
        const pdp_elements = document.querySelectorAll('[data-pdp-delivery-message]');
        // If it isn't 'undefined' and it isn't 'null', then it exists.
        pdp_elements.forEach((pdp_element) => {
          if (typeof pdp_element !== 'undefined' && pdp_element != null) {
            if (pdp_element.classList.contains('override')) {
              pdp_element.classList.remove('override');
              return;
            }

            if (window.theme.shipping_message_override) {
              pdp_element.innerHTML = window.theme.pdp_delivery_message;
            } else {
              const shippingMessage = window.SH_SHIPPING_MESSAGE;
              const { day, hours } = shippingMessage.getStoreTimeInfo(window.theme.shipping_cutoff_timezone, window.theme.shop_utc_offset);
              const hour_cutoff = parseInt(window.theme.pdp_delivery_time_cutoff);

              const personalizationOptinYes = document.querySelector(
                '.product-customize__buttons [data-personalization-value="yes"]'
              );

              if (personalizationOptinYes && personalizationOptinYes.classList.contains('active')) {
                pdp_element.innerHTML = shippingMessage.compose(window.theme.pdp_delivery_message_personalization);
              } else {
                const slot = shippingMessage.resolveDispatchDaySlot(day, hours, hour_cutoff);
                pdp_element.innerHTML = shippingMessage.compose(window.theme[`pdp_delivery_message_${slot}`]);
              }
            }
          } else {
            // console.log( 'Cannot find element.' );
            return;
          }
        });
      };

      updateProductDetail(variant) {
        const variant_metafield_obj = this.variant_metafields.variants.find((v) => v.id === variant.id);
        if (!variant_metafield_obj) return;
        // create data selectors within data-product-spec for each product spec
        const dataProductSpec = document.querySelector('[data-product-spec]');
        if (dataProductSpec == null) return;
        const selectors = {
          // specVariantMaterial: '[spec-variant-material]',
          specProductCapacity: '[spec-product-capacity]',
          specProductIngredients: '[spec-product-ingredients]',
          specProductLinerCode: '[spec-product-linercode]',
          specProductPowerSource: '[spec-product-powersource]',
          specProductMagnification: '[spec-product-magnification]',
          specProductCompatibility: '[spec-product-compatibility]',
          specProductBatteryLife: '[spec-product-batterylife]',
          specProductWhatIsInBox: '[spec-product-whatisinbox]',
          specVariantWarranty: '[spec-variant-warranty]',
          specVariantSku: '[spec-variant-sku]',
          specVariantCoating: '[spec-variant-coating]',
        };
        if (variant.sku) {
          dataProductSpec.querySelector(selectors.specVariantSku).textContent = variant.sku;
        }
        // if (variant_metafield_obj.material) {
        //   dataProductSpec.querySelector('[spec-variant-material]').textContent = variant_metafield_obj.material;
        // }
        if (variant_metafield_obj.warranty) {
          dataProductSpec.querySelector(selectors.specVariantWarranty).textContent = variant_metafield_obj.warranty;
        }
        if (variant_metafield_obj.coating) {
          // get closest .product-spec__copy-inner and show it
          dataProductSpec
            .querySelector(selectors.specVariantCoating)
            .closest('.product-spec__copy-inner').style.display = 'flex';
          dataProductSpec.querySelector(selectors.specVariantCoating).textContent = variant_metafield_obj.coating;
        } else {
          // get closest .product-spec__copy-inner and hide it
          dataProductSpec
            .querySelector(selectors.specVariantCoating)
            .closest('.product-spec__copy-inner').style.display = 'none';
          dataProductSpec.querySelector(selectors.specVariantCoating).textContent = '';
        }
        if (variant_metafield_obj.capacity && dataProductSpec.querySelector(selectors.specProductCapacity)) {
          dataProductSpec.querySelector(selectors.specProductCapacity).textContent = variant_metafield_obj.capacity;
        }
        if (variant_metafield_obj.ingredients && dataProductSpec.querySelector(selectors.specProductIngredients)) {
          dataProductSpec.querySelector(selectors.specProductIngredients).textContent =
            variant_metafield_obj.ingredients;
        }
        // liner_code is product-level (rendered as a colored bubble); skip variant-level
        // textContent assignment which would wipe the bubble HTML.
        if (variant_metafield_obj.power_source && dataProductSpec.querySelector(selectors.specProductPowerSource)) {
          dataProductSpec.querySelector(selectors.specProductPowerSource).textContent =
            variant_metafield_obj.power_source;
        }
        if (variant_metafield_obj.magnification && dataProductSpec.querySelector(selectors.specProductMagnification)) {
          dataProductSpec.querySelector(selectors.specProductMagnification).textContent =
            variant_metafield_obj.magnification;
        }
        if (variant_metafield_obj.compatibility && dataProductSpec.querySelector(selectors.specProductCompatibility)) {
          dataProductSpec.querySelector(selectors.specProductCompatibility).textContent =
            variant_metafield_obj.compatibility;
        }
        if (variant_metafield_obj.battery_life && dataProductSpec.querySelector(selectors.specProductBatteryLife)) {
          dataProductSpec.querySelector(selectors.specProductBatteryLife).textContent =
            variant_metafield_obj.battery_life;
        }
        if (variant_metafield_obj.whatisinbox && dataProductSpec.querySelector(selectors.specProductWhatIsInBox)) {
          dataProductSpec.querySelector(selectors.specProductWhatIsInBox).textContent =
            variant_metafield_obj.whatisinbox;
        }
        //    if (variant_metafield_obj.variant_exclusive) {
        //      $(".ProductHeading__exclusive").html(variant_exclusive);
        //    } else {
        //      $(".ProductHeading__exclusive").empty();
        //    }
        if (variant_metafield_obj.variant_exclusive && document.querySelector('.ProductHeading__exclusive')) {
          document.querySelectorAll('.ProductHeading__exclusive').forEach((element) => {
            element.innerHTML = variant_metafield_obj.variant_exclusive;
          });
        } else {
          document.querySelectorAll('.ProductHeading__exclusive').forEach((element) => {
            element.innerHTML = '';
          });
        }
      }

      scrollAndClick() {
        const scrollLinks = document.querySelectorAll('[data-scroll-link-to]');
        // add event listener to each element
        scrollLinks.forEach((scrollLink) => {
          scrollLink.addEventListener('click', (e) => {
            e.preventDefault();
            // get value of the scrollLink
            const value_of_scroll_link = scrollLink.getAttribute('data-scroll-link-to');
            if (value_of_scroll_link) {
              // scroll to top of page smooth
              window.scrollTo({ top: 0, behavior: 'smooth' });
              // get the value of the target element's data-scroll-link-to attribute
              // find the element with the id that matches the value of the data-scroll-link-to attribute
              const variantElement = document.querySelector(
                `.ProductOption__variants [data-value="${value_of_scroll_link}"]`
              );
              if (!variantElement) return;
              // wait until scroll has finished, then click
              setTimeout(() => {
                variantElement.click();
              }, 500);
            }
          });
        });
      }

      updateMainProductSummary(variant) {
        if (this.debug) console.log('updateMainProductSummary with variant id:', variant.id);
        const product = document.querySelector('product-info[id^="MainProduct"]');
        const mainProductTitle = product.getAttribute('data-product-cart-title');
        const mainProductModifier = product.getAttribute('data-product-name-modifier');
        if (this.debug) console.log(variant.options);
        // instead of checking inputs that are checked, we just get the options from the selected variant
        // strip out "Default Title" from the options
        let arrVariantOptions = variant.options.filter((option) => option !== 'Default Title');

        const productDetails = [mainProductModifier, ...arrVariantOptions]
          .filter(Boolean)
          .join(window.SH_PIPE_SEPARATOR);
        if (this.debug) console.log(productDetails);
        setTimeout(() => {
          // Check if there is an element with the class .product-customize
          if (document.querySelectorAll('.product-customize').length) {
            const typeCustomize = document.querySelector('[data-pr-type]')?.dataset?.prType;
            const element = document.querySelector('[data-summary-main-product] [data-summary-item-details]');
            const isActive = document.querySelector('.product-customize.active') !== null;

            if (element && typeCustomize) {
              if (isActive && !element.textContent.includes(typeCustomize)) {
                // If active, add typeCustomize
                element.textContent += ` | ${typeCustomize}`;
              } else if (!isActive && element.textContent.includes(` | ${typeCustomize}`)) {
                // If not active, remove typeCustomize and the preceding slash
                element.textContent = element.textContent.replace(` | ${typeCustomize}`, '');
              }
            }
          }
        }, 150);

        setSummaryItem('[data-summary-main-product]', mainProductTitle, productDetails);
      }

      // Handles lazy-loading images using requestIdleCallback or a fallback.
      loadLazyImagesWithFallback() {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => {
            if (window.lazyLoadInstance && typeof window.lazyLoadInstance.loadAll === 'function') {
              window.lazyLoadInstance.loadAll();
            }
          });
        } else {
          // Fallback for browsers without requestIdleCallback
          setTimeout(() => {
            if (window.lazyLoadInstance && typeof window.lazyLoadInstance.loadAll === 'function') {
              window.lazyLoadInstance.loadAll();
            }
          }, 200); // Small delay to avoid blocking critical tasks
        }
      }

      updatePriceMarkup(originalPrice, salePrice, priceBuyBar, priceAndDeliveryView) {
        const priceMarkup = `
          <div class="price__container price--on-sale">
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">Regular price</span>
              <span class="price-item price-item--regular">${originalPrice}</span>
            </div>
            <div class="price__sale">
              <span class="visually-hidden visually-hidden--inline">Regular price</span>
              <span><s class="price-item price-item--regular">${originalPrice}</s></span>
              <span class="visually-hidden visually-hidden--inline">Sale price</span>
              <span class="price-item price-item--sale price-item--last">${salePrice}</span>
            </div>
            <small class="unit-price caption hidden">
              <span class="visually-hidden">Unit price</span>
              <span class="price-item price-item--last">
                <span></span><span aria-hidden="true">/</span><span class="visually-hidden">&nbsp;per&nbsp;</span><span></span>
              </span>
            </small>
          </div>`;

        if (priceBuyBar) {
          priceBuyBar.innerHTML = priceMarkup;
        }
        if (priceAndDeliveryView) {
          priceAndDeliveryView.innerHTML = priceMarkup;
        }
      }

      /**
       * Adds event listeners for handling subscription-related actions on the product page.
       *
       * This method performs the following:
       * - Listens for clicks on subscription options and updates the selection.
       * - Listens for clicks on other product options to clear the selected subscription.
       *
       * @returns {void}
       *
       * @example
       * // Attach the listeners for subscription interactions
       * this.addSubscriptionListeners();
       */
      addSubscriptionListeners() {
        console.log('addSubscriptionListeners');

        const productInfoWrapper = this.querySelector('[data-product-subscriptions]');
        if (!productInfoWrapper) return;

        productInfoWrapper.addEventListener('click', (event) => {
          const clickedOption = event.target.closest('[data-subscription-option]');
          if (!clickedOption || clickedOption.classList.contains('selected')) return;

          this.handleSubscriptionSelection(clickedOption);
        });

        document.querySelector('.product__info-wrapper').addEventListener('click', (event) => {
          if (event.target.closest('.ProductOption__option')) {
            this.clearSubscriptionSelection();
          }
        });
      }

      /**
       * Handles the selection of a subscription option on the product page.
       *
       * This method updates the UI based on the selected subscription option, including
       * updating price details, changing the active subscription state, and updating
       * feature images if applicable. It also unchecks any selected quantity radio buttons
       * and adjusts the summary text if applicable.
       *
       * @param {HTMLElement} option - The subscription option element that was selected.
       */
      handleSubscriptionSelection(option) {
        const subscriptionOptions = document.querySelectorAll('[data-subscription-option]');
        const inputSellingPlan = document.querySelector('input[data-selling-plan-id]');
        const inputVariantId = document.querySelector('input[name="id"].product-variant-id');
        const priceView = document.querySelector('.price-and-delivery .price-general');
        const productElement = document.querySelector('.product');
        const summaryText = document.querySelector('[data-summary-main-product] [data-summary-item-details]');

        // Unselect all subscription options
        subscriptionOptions.forEach((item) => item.classList.remove('selected'));

        // Select the clicked option
        option.classList.add('selected');

        // Update input values
        if (inputSellingPlan) inputSellingPlan.value = option.getAttribute('data-subscription-id');
        if (inputVariantId) inputVariantId.value = option.getAttribute('data-variant-id');

        // Update price markup
        this.updatePriceMarkup(
          option.getAttribute('data-variant-original-price'),
          option.getAttribute('data-variant-price'),
          false,
          priceView
        );

        // Mark product as inactive
        if (productElement) productElement.classList.add('inactive');

        // Handle feature image update if applicable
        const featureImageId = option.getAttribute('data-feature-image-id');
        if (featureImageId) this.updateMedia(this, featureImageId);

        // Uncheck all radio buttons
        document.querySelectorAll('.type-quantity input[type="radio"]').forEach((radio) => {
          radio.checked = false;
        });

        // Update summary text if applicable
        if (summaryText && option.hasAttribute('data-subscription-selected-copy')) {
          // Split and rejoin on the full separator. Splitting on a bare '|' left the
          // leading en space stranded on the previous segment, and the asymmetric
          // '| ' rejoin then rendered a wide gap before the pipe and a narrow one after.
          let summaryParts = summaryText.textContent.split(window.SH_PIPE_SEPARATOR);
          summaryParts[summaryParts.length - 1] = option.getAttribute('data-subscription-selected-copy');
          summaryText.textContent = summaryParts.join(window.SH_PIPE_SEPARATOR);
        }
      }

      /**
       * Clears the selected subscription options on the product page.
       *
       * This method removes the "selected" class from all subscription options,
       * resets the value of the selling plan input, and marks the product element as active
       * if it was inactive.
       */
      clearSubscriptionSelection() {
        const subscriptionOptions = document.querySelectorAll('[data-subscription-option].selected');

        if (subscriptionOptions.length > 0) {
          const sellingPlanInput = document.querySelector('input[data-selling-plan-id]');
          const productElement = document.querySelector('.product');

          subscriptionOptions.forEach((option) => option.classList.remove('selected'));

          if (sellingPlanInput) sellingPlanInput.setAttribute('value', '');
          if (productElement) productElement.classList.remove('inactive');
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
